import { Box, Typography, Button } from "@mui/material"
import { MakeAmountStyle } from '@utils/dataHelper'
import USDC_ICON from '@images/ico_usdc.png'
import "./MyStakeItem.scss"
import "../StakeItem/StakeItem.scss"

const MyStakeItem = (props) => {
  const {
    stakeInfo,
    presaleAmount,
    maxsaleAmount,
    status,
    isUnstaking,
    unStakeHandler,
    overUnStakeHandler,
    isOwn,
    disableUnstakeBtn
  } = props;

  const amount = Number(stakeInfo.amount) + Number(stakeInfo.restAmount)
  const stakedAmount = MakeAmountStyle(amount, true)
  const bonus = Number(stakeInfo.bonus)
  const position = stakeInfo.position.toString()

  let isOverStake = false
  let restAmount = 0
  let overAmount = 0 // This is the over amount than presale
  let avgBonus = bonus
  let unStakeAmount = 0 // This amount is used for unstaking over stakes than max sale

  if (status < 5) {
    isOverStake = presaleAmount > stakeInfo.stakedAmount && presaleAmount < stakeInfo.stakedAmount + amount

    if (isOverStake) {
      restAmount = presaleAmount - stakeInfo.stakedAmount;
      overAmount = amount - restAmount;
      avgBonus = (restAmount / amount * bonus).toFixed(2);
    }
  }

  let isUnderOverUnstake = false
  let isOverUnstake = status > 2 && status < 5 && maxsaleAmount < stakeInfo.stakedAmount + amount
  if (isOverUnstake) {
    isUnderOverUnstake = maxsaleAmount > stakeInfo.stakedAmount
    unStakeAmount = isUnderOverUnstake ? (stakeInfo.stakedAmount + amount - maxsaleAmount) : amount;
    overAmount = isUnderOverUnstake ? overAmount - unStakeAmount : overAmount
  }

  restAmount = MakeAmountStyle(restAmount, true);
  overAmount = MakeAmountStyle(overAmount, true);
  unStakeAmount = MakeAmountStyle(unStakeAmount, true);

  return (
    <Box
      className={`my-staked-item ${status === 5 ? 'bg-gray' : isOwn ? isUnstaking ? 'bg-blue-dark' : 'bg-yellow' : 'bg-gray'}`}
    >
      <Box className={`top ${isOverStake && "box-shadow"}`}>
        {isOwn ? (
          <Box
            sx={{ display: "flex" }}
          >
            <Box
              className="text-center"
              sx={{ mr: 3 }}
            >
              <Typography
                className="font-24 font-bold"
              >
                {position}
              </Typography>
              <Typography
                className="font-sm font-bold"
              >
                MY POSITION
              </Typography>
            </Box>
            {isUnstaking && !disableUnstakeBtn && (
              <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                <Button
                  className="btn-unstake"
                  onClick={unStakeHandler}
                >
                  UN-STAKE
                </Button>
              </Box>
            )}
            {isOverUnstake && !isUnderOverUnstake && !disableUnstakeBtn && (
              <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                <Button
                  className="btn-unstake"
                  onClick={overUnStakeHandler}
                >
                  UN-STAKE
                </Button>
              </Box>
            )}
          </Box>
        ) : (
          <Box
            className="text-center"
          >
            <Typography
              className="font-24 font-bold"
            >
              {position}
            </Typography>
            <Typography
              className="font-sm font-bold"
            >
              POSITION
            </Typography>
          </Box>
        )}
        <Box
          sx={{ display: "flex" }}
        >
          {status < 5 && (
            <Box className="text-center">
              <Typography
                className={`font-24 font-bold ${isUnstaking ? 'text-yellow' : 'text-white'}`}
                sx={{ mr: 1 }}
              >
                {Number(avgBonus)}%
              </Typography>
              <Typography
                className="font-sm text-white"
              >
                PRESAIL BONUS
              </Typography>
            </Box>
          )}
          <Box
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', ml: 3 }}
          >
            <Box
              className="text-center"
              sx={{ mr: 1 }}
            >
              <Typography
                className="font-24 font-bold"
              >
                ${stakedAmount}
              </Typography>
              <Typography
                className="font-sm font-bold"
              >
                {isOwn ? "MY STAKE" : "STAKE"}
              </Typography>
            </Box>
            <Box className="coin-icon">
              <img
                src={USDC_ICON}
                alt="USDC Icon"
              />
            </Box>
          </Box>
        </Box>
      </Box>
      {isOverStake && !disableUnstakeBtn && (
        <Box className="bottom">
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                className={`font-20 font-bold ${isUnstaking ? 'text-yellow' : 'text-white'}`}
                sx={{ mr: 1 }}
              >
                {Number(bonus)}%
              </Typography>
              <Typography
                className="font-sm text-white"
              >
                PRESAIL BONUS
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                className="font-20 font-bold text-white"
              >
                ${restAmount}
              </Typography>
              <Box className="coin-icon" sx={{ ml: 1 }}>
                <img
                  src={USDC_ICON}
                  alt="USDC Icon"
                  className="sm"
                />
              </Box>
            </Box>
          </Box>
          <hr style={{ margin: "3px 0px" }} />
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                className={`font-20 font-bold ${isUnstaking ? 'text-yellow' : 'text-white'}`}
                sx={{ mr: 1 }}
              >
                0%
              </Typography>
              <Typography
                className="font-sm text-white"
              >
                PRESAIL BONUS
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                className="font-20 font-bold text-white"
              >
                ${overAmount}
              </Typography>
              <Box className="coin-icon" sx={{ ml: 1 }}>
                <img
                  src={USDC_ICON}
                  alt="USDC Icon"
                  className="sm"
                />
              </Box>
            </Box>
          </Box>
          {
            isUnderOverUnstake && (
              <>
                <hr style={{ margin: "3px 0px" }} />
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      className={`font-20 font-bold ${isUnstaking ? 'text-yellow' : 'text-white'}`}
                      sx={{ mr: 1 }}
                    >
                      0%
                    </Typography>
                    <Typography
                      className="font-sm text-white"
                    >
                      PRESAIL BONUS
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                    <Button
                      className="btn-unstake"
                      onClick={overUnStakeHandler}
                    >
                      UN-STAKE
                    </Button>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      className="font-20 font-bold text-white"
                    >
                      ${unStakeAmount}
                    </Typography>
                    <Box className="coin-icon" sx={{ ml: 1 }}>
                      <img
                        src={USDC_ICON}
                        alt="USDC Icon"
                        className="sm"
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            )
          }
        </Box>
      )}
    </Box>
  )
}

export default MyStakeItem;